import { render, staticRenderFns } from "./EditCampus.vue?vue&type=template&id=22994276&scoped=true"
import script from "./EditCampus.vue?vue&type=script&lang=js"
export * from "./EditCampus.vue?vue&type=script&lang=js"
import style0 from "./EditCampus.vue?vue&type=style&index=0&id=22994276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22994276",
  null
  
)

export default component.exports